export default function logComponent(componentName) {
  const logNever = true;
  const logAll = false;
  const logAllExcept = false;
  const logOnly = true;
  const logExceptionComponents = ['MobileMenu', 'MobileMenuLink', 'Timer', 'Weather', 'WeatherIcon', 'InactivityLogout'];
    const logOnlyComponents = [
      'Checkbox',
      'CheckboxGroup',
      'CheckboxListInput',
      'ContactUsContents',
      'ContactUsAPI'
  ];
  const isDev = process.env.NODE_ENV === 'development';
  const shouldLog =
    isDev && (
      logAll === true ? true :
        logNever === true ? false :
          logAllExcept === true && !logExceptionComponents.includes(componentName) ? true :
            logOnly === true && logOnlyComponents.includes(componentName) ? true :
              false);
  return shouldLog;
}
